import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { getFirestore, doc, onSnapshot } from "firebase/firestore";

export function useUserAvatar(userId) {
  const { user, avatarUrl: myAvatar } = useAuth();
  const [url, setUrl] = useState("/img/avatar2.jpg");
  const firestore = getFirestore();

  useEffect(() => {
    if (!userId) return;

    // Si es mi propio usuario, devuelvo mi avatar del contexto
    if (user && user.uid === userId) {
      setUrl(myAvatar || "/img/avatar2.jpg");
      return;
    }

    // Si es otro usuario, suscríbete al documento de Firestore
    const userDocRef = doc(firestore, "usuarios", userId);
    const unsub = onSnapshot(userDocRef, (snap) => {
      const data = snap.data();
      setUrl(data?.avatarUrl || "/img/avatar2.jpg");
    });
    return () => unsub();
  }, [userId, user, myAvatar, firestore]);

  return url;
}